import { isEqual } from "underscore";
import { onEachComponent } from "../lib/componentHelpers";
const blocks = [...require("./Landing"), ...require("./TextPage"), ...require("./LandingSolo")];

export default function (editor) {
  const { DomComponents } = editor;

  const hidden = {
    copyable: false,
    draggable: false,
    droppable: false,
    removable: false,
    selectable: false,
    stylable: false,
    hoverable: false,
    resizable: false,
    editable: false,
  };

  const editable = {
    selectable: true,
    editable: true,
    hoverable: true,
    highlightable: false,
  };

  DomComponents.addType("default", {
    model: {
      defaults: hidden,
    },
  });

  DomComponents.addType("text", {
    model: {
      defaults: {
        ...hidden,
        ...editable,
        stylable: ["text-align", "color"],
      },
    },
  });

  DomComponents.addType("image", {
    model: {
      defaults: {
        ...hidden,
        ...editable,
      },
    },
  });

  DomComponents.addType("link", {
    model: {
      defaults: {
        ...hidden,
        ...editable,
      },
    },
  });

  // Make styles editable for specific elements instead of it's class
  editor.SelectorManager.getAll().each(selector => selector.set("private", 1));
  editor.on("selector:add", selector => selector.set("private", 1));

  // Add data-gjs- attributes to DOM/HTMLs
  const gjsAttributes = [
    "copyable",
    "draggable",
    "droppable",
    "removable",
    "selectable",
    "stylable",
    "hoverable",
    "resizable",
    "type",
    "name",
  ];

  const updateGJSAttribute = function (model, attr) {
    const allProps = model.props();
    const currentProp = allProps[attr];
    const defaultProp = DomComponents.getType(model.get("type") || "default").model.prototype.defaults[attr];
    if ((attr == "type" && currentProp) || !isEqual(currentProp, defaultProp)) {
      model.addAttributes({
        [`data-gjs-${attr}`]: typeof currentProp == "string" ? currentProp : JSON.stringify(currentProp),
      });
    }
  };
  editor.on("component:mount", model => gjsAttributes.forEach(attr => updateGJSAttribute(model, attr)));
  gjsAttributes.forEach(attr => editor.on("component:update:" + attr, model => updateGJSAttribute(model, attr)));
  editor.on("component:mount", model => {
    if (["", "default", "text", "link"].includes(model.get("type")) && model.closestType("text")) {
      model.set({
        draggable: false,
        highlightable: false,
        editable: false,
      });
      model.addAttributes({ draggable: false });
    }
  });

  editor.on("rte:action:button-status", data => {
    if (["bulletedList", "numberedList"].includes(data.type)) {
      if (data.el.matches("a,a *")) data.enabled = false;
    }
  });

  blocks.forEach(b => b.default(editor));

  editor.on("storage:loaded", () => {
    const canvasDoc = editor.Canvas.getDocument();
    canvasDoc.head.querySelectorAll("style").forEach(s => {
      if (s.getAttribute("data-type") !== null) s.remove();
    });
  });

  const addStyleToHead = (type, css) => {
    const canvasDoc = editor.Canvas.getDocument();

    if (canvasDoc.head.querySelector(`style[data-type=${type}]`)) return;
    const styleEl = canvasDoc.head.appendChild(canvasDoc.createElement("style"));
    styleEl.setAttribute("data-type", type);
    styleEl.appendChild(canvasDoc.createTextNode(css));
  };

  const removeStyleFromHead = type => {
    const canvasDoc = editor.Canvas.getDocument();

    const style = canvasDoc.head.querySelector(`style[data-type=${type}]`);
    if (style) style.remove();
  };

  editor.on("component:mount", model => {
    // Strip all styles except IDs from body
    const allRules = editor.CssComposer.getAll();
    allRules.set(
      allRules.filter(rule => {
        return rule.selectorsToString().startsWith("#");
      })
    );

    // Embed common fonts
    addStyleToHead(
      "font-import-montserrat",
      "@import url('https://fonts.googleapis.com/css2?family=Montserrat:ital,wght@0,400;0,500;0,600;1,400;1,500;1,600&display=swap');"
    );

    // Add component styles to HEAD
    const block = editor.BlockManager.get(model.get("type"));
    if (block !== undefined) {
      const content = block.get("content");
      const searchPattern = /<style data-type=["'](.*?)["']>(.*?)<\/style>/gis;
      let search;
      while ((search = searchPattern.exec(content)) !== null) {
        addStyleToHead(search[1], search[2]);
      }
    }
  });

  editor.on("component:remove", model => {
    const block = editor.BlockManager.get(model.get("type"));
    if (block !== undefined) {
      let count = 0;
      onEachComponent(DomComponents.getWrapper(), c => {
        if (c.get("type") === model.get("type")) count++;
      });
      if (count === 0) removeStyleFromHead(model.get("type"));
    }
  });
}
